import {Component, inject, model, OnInit} from '@angular/core'
import {PleaseWaitComponent} from '../../../components/please-wait/please-wait.component'
import {KycService, PutKycResponse} from '../../../services/kyc.service'
import {catchError, NEVER} from 'rxjs'

@Component({
  selector: 'spb-approve',
  imports: [
    PleaseWaitComponent
  ],
  templateUrl: './approve.component.html',
  styleUrl: './approve.component.scss'
})
export class ApproveComponent implements OnInit {
  public data = model.required<PutKycResponse>()

  private readonly service = inject(KycService)

  public ngOnInit() {
    this.service.putKyc()
      .pipe(
        catchError(() => {
          this.data.set({errorMessage: 'Kunde inte kontakta servern'})
          return NEVER
        })
      )
      .subscribe(
        data => {
          this.data.set(data)
        }
      )
  }
}
